<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import Drawer from '../common/Drawer.svelte';

  export let bg = 'bg-white';
  export let collapsable = true;
  export let isFullyHide = false;

  const dispatch = createEventDispatcher();

  export let isCollapsed;
</script>

<div class="z-50 block w-full lg:hidden">
  <Drawer
    {bg}
    bind:isCollapsed
    on:drawerCollapsed={() => dispatch('ModalClose')}
    {collapsable}
    {isFullyHide}
  >
    <div class="flex flex-col items-center justify-center w-full rounded-t-30" slot="handle">
      <div class="my-4 rounded-full w-10 h-[6px] bg-color-gray-line" />
      <slot name="message" />
    </div>

    <div
      class="w-full max-w-md m-auto {bg} items-center p-5 pb-16 overflow-y-scroll max-h-[90vh]"
      slot="content"
    >
      <slot />
    </div>
  </Drawer>
</div>
